export default "/images/1240c6ae6a45f47de0596c3ed6dbde36.avif";